import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  summaryContainer: {
    padding: theme.spacing(2),
  },
  summaryCard: {
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    borderColor: theme.palette.custom.border,
  },
  summaryHeader: {
    padding: theme.spacing(3, 4),
    borderBottom: `1px solid ${theme.palette.custom.border}`,
  },
  summaryButton: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: '180px',
    },
    [theme.breakpoints.up('md')]: {
      width: '180px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '220px',
    },
  },
  largeScaleButton: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: '180px',
    },
    [theme.breakpoints.up('md')]: {
      width: '180px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '220px',
    },
  },
  summaryTitle: {
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  row: {
    padding: theme.spacing(3, 4),
    borderBottom: `1px solid ${theme.palette.custom.border}`,
  },
  rowTitle: {
    fontWeight: 700,
  },
  rowSubtitle: {
    color: theme.palette.secondary.main,
    fontStyle: 'italic',
    marginTop: theme.spacing(0.5),
  },
  chipColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      marginTop: theme.spacing(1),
    },
  },
  chip: {
    border: `1px solid ${theme.palette.custom.border}`,
    fontWeight: 700,
    minWidth: 64,
  },

  finalRow: {
    padding: theme.spacing(3, 4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2),
    },
  },
  finalTitleYes: {
    color: theme.palette.error.main,
    fontWeight: 800,
    letterSpacing: '0.02em',
  },
  finalSubtitleYes: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
  },
  resultLabelYes: {
    color: theme.palette.error.main,
    fontSize: '0.75rem',
    letterSpacing: '0.1em',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  finalTitleNo: {
    color: theme.palette.primary.hover,
    fontWeight: 800,
    letterSpacing: '0.02em',
  },
  finalSubtitleNo: {
    color: theme.palette.primary.hover,
    marginTop: theme.spacing(0.5),
  },
  resultLabelNo: {
    color: theme.palette.primary.hover,
    fontSize: '0.75rem',
    letterSpacing: '0.1em',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  infoButton: {
    padding: 4,
    minWidth: 0,
    '& svg': {
      width: 14,
      height: 14,
    },
  },
}))

export default styles
